// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { TermsOfUseArticle } from "../../common/legal/TermsOfUseArticle";
import {
    TERMS_OF_USE_ROUTE,
} from "../../../../core/constants/route";
import {
    T_SITE_NAME,
    T_TERMS_OF_USE_ROUTE_DESCRIPTION,
    T_TERMS_OF_USE_ROUTE_TITLE,
} from "../../../../core/constants/translation";
import { TERMS_OF_USE_VIEW_CLASS_NAME } from "../../../../core/constants/className";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../common/seo/SEODiv";
import "./TermsOfUseView.scss";

export interface TermsOfUseViewProps {
    readonly t ?: TranslationFunction;
}

export function TermsOfUseView (props: TermsOfUseViewProps) {
    const t : TranslationFunction = props?.t ?? ((key: string) : string => key);
    return (
        <SEODiv className={TERMS_OF_USE_VIEW_CLASS_NAME}
                path={TERMS_OF_USE_ROUTE}
                title={t(T_TERMS_OF_USE_ROUTE_TITLE)}
                description={t(T_TERMS_OF_USE_ROUTE_DESCRIPTION)}
                siteName={t(T_SITE_NAME)}
        >
            <TermsOfUseArticle />
        </SEODiv>
    );
}
